<template>
  <div id="main" class="login valign-wrapper gradiente-mpf">
    <div class="wrapper card-panel">
      <div class="row">
        <div class="col s12 m12 l6 imagenes">
          <div class="row">
            <div class="col m4 l4"></div>
            <div class="col m4 l4"></div>
            <div class="col m4 l4"></div>
          </div>
        </div>
        <div id="basic-form" class="section col s12 m12 l6">
          <div class="row">
            <h4 class="header2">Firmador de Documentos</h4>
            <form class="col s12 m12 l8 xl6" @submit.prevent="doLogin">
              <div class="row">
                <div class="input-field col s12">
                  <input
                    type="text"
                    id="email"
                    v-model="username"
                    name="username"
                    autocomplete="off"
                    characterCounter="off"
                    :class="{ 'is-invalid': submitted && !username }"
                  />
                  <div
                    v-show="submitted && !username"
                    class="invalid-feedback"
                  >Nombre de usuario es requerido</div>
                  <label for="email" class="active">Nombre de Usuario</label>
                </div>
              </div>
              <div class="row">
                <div class="input-field col s12">
                  <label for="password" class="active">Contraseña</label>
                  <input
                    type="password"
                    id="password"
                    name="password"
                    v-model="password"
                    :class="{ 'is-invalid': submitted && !password }"
                  />
                  <div
                    v-show="submitted && !password"
                    class="invalid-feedback"
                  >La Contraseña es requerida</div>
                </div>
              </div>
              <div class="row">
                <div class="col s12 input-field">
                  <vue-recaptcha
                    ref="recaptcha"
                    @verify="onCaptchaVerified"
                    @expired="onCaptchaExpired"
                    :sitekey="captchaKey"
                  ></vue-recaptcha>
                  <div v-show="submitted && errorOnLogIn" class="invalid-feedback">{{errorMessage}}</div>
                </div>
                <div class="input-field col s12 destacado">
                  <a href="#">Recuperar Contraseña</a>
                  <button
                    submit="doLogin()"
                    class="btn waves-effect waves-light"
                    type="submit"
                    name="action"
                    :disabled="!captchaOk"
                  >
                    Ingresar
                    <i class="material-icons right">send</i>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
import EnvProvider from 'jvjr-docker-env';

export default {
  name: "login",
  components: { VueRecaptcha },
  props: {
    msg: String
  },
  data() {
    return {
      username: "",
      password: "",
      submitted: false,
      errorOnLogIn: false,
      errorMessage: "",
      captchaOk: false,
      captchaKey: EnvProvider.value('CAPTCHA_SITE_KEY')
    };
  },
  methods: {
    doLogin() {
      let loader = this.$loading.show({
        container: this.fullPage,
        canCancel: false
      });
      this.submitted = true;
      this.$store
        .dispatch("login", {
          usuario: this.username,
          password: btoa(this.password)
        })
        .then(response => {        
          loader.hide();  
          this.errorOnLogIn = response.data.status == "ok" ? false : true;
          this.$router.push({ name: "subir" });
        })
        .catch(error => {
          loader.hide();  
          this.errorOnLogIn = true;         
          this.errorMessage = error.response.data.description;
        });
    },
    submit: function() {
      // this.status = "submitting";
      this.$refs.recaptcha.execute();
    },
    onCaptchaVerified: function(recaptchaToken) {
      this.$store
        .dispatch("captcha", {
          recaptchaToken
        })
        .then(response => {
          this.captchaOk = response ? true : false;
        })
        .catch(error => {
          this.captchaOk = error ? true : false;
        });
    },
    onCaptchaExpired: function() {
      this.captchaOk = false;
      this.$refs.recaptcha.reset();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>